const blogData = [
  {
    id: 1,
    image: "https://mindingyourmedia.com/wp-content/uploads/2023/08/Revolutionizing-Digital-Marketing-Unveiling-the-Power-of-AI-and-Minding-Your-Media.jpg",
    date: "August 10, 2023",
    title: "Revolutionizing Digital Marketing with AI",
    description: "Discover how AI is transforming the digital marketing landscape and strategies.",
    link: "#"
  },
  {
    id: 2,
    image: "https://web-balance.co.uk/wp-content/uploads/2022/09/Waverley-mockups.jpg",
    date: "September 15, 2022",
    title: "Creative Web Design Mockups",
    description: "An in-depth look at designing innovative web mockups for modern websites.",
    link: "#"
  },
  {
    id: 3,
    image: "https://cdn.prod.website-files.com/637859b9a818d7ddb05bb5fb/65046f330ca1db2478958cbb_The-Evolution-of-SEO-in-2023-What-You-Need-to-Know-2048x1518.jpg",
    date: "January 5, 2023",
    title: "The Evolution of SEO in 2023",
    description: "Stay updated with the latest SEO trends and how they affect your website ranking.",
    link: "#"
  },
  {
    id: 4,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMJgJgRMS916Nv903Q3eZiVz708JHnDoFMDw&s",
    date: "March 12, 2024",
    title: "Mobile App Development Trends",
    description: "Learn about the latest trends and technologies shaping mobile app development in 2024.",
    link: "#"
  },
  {
    id: 5,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWyPGHmxooSsGnEtZRDm7AF0DoX-h0FH-d8A&s",
    date: "April 20, 2024",
    title: "Blockchain Development Explained",
    description: "Understand blockchain technology, smart contracts, and its growing importance in tech.",
    link: "#"
  }
];

export default blogData;
